import { gql } from '@apollo/client'

const UPDATE_DIET_CATEGORY_DETAILS_MUTATION = gql`
  mutation updateDietCategoryDetails(
    $id: ID!
    $data: DietCategoryDetailsInput!
  ) {
    updateDietCategoryDetails(id: $id, data: $data) {
      id
      description
      descriptionUrl
      position
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export default UPDATE_DIET_CATEGORY_DETAILS_MUTATION
